/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(_components.p, null, "A work in progress video walkthrough of the Digital Twin for the LSU Museum of Art. The primary use case it to design exhibits digitally, from wall color to art placement. This opens up the possibility for a virtual gallery, event planning, renovation design, and more. Using real time rendering in Unreal Engine, and modeled in Blender, the Game, VFX, and Animation skillsets taught in our program are in high demand across Architectural, Engineering, and many other fields.");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
